/**
 * Premium PDP: accordion toggles, desktop hover gallery auto-slide, mobile scroll passthrough.
 */
(function () {
  var DESKTOP_MQL = window.matchMedia('(min-width: 990px)');
  var MOBILE_MQL = window.matchMedia('(max-width: 989px)');
  var HOVER_SLIDE_MS = 5000;
  var MOBILE_SCROLL_SYNC_MS = 120;
  var THUMB_SCROLL_SETTLE_MS = 480;
  var THUMB_ANIM_MS = 380;

  function debounce(fn, ms) {
    var timer = null;
    return function () {
      var ctx = this;
      var args = arguments;
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        timer = null;
        fn.apply(ctx, args);
      }, ms);
    };
  }

  function initAccordions(scope) {
    scope.querySelectorAll('.skipp-pdp-details-root .accordion-toggle').forEach(function (btn) {
      if (btn.dataset.skippPdpAccordionBound) return;
      btn.dataset.skippPdpAccordionBound = '1';
      btn.addEventListener('click', function () {
        var acc = btn.closest('.pdp-accordion');
        if (!acc) return;
        var open = acc.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var panel = acc.querySelector('.accordion-content');
        if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      });
    });
  }

  function getPagedList(host) {
    return host.querySelector('ul.pdp-image-grid--paged');
  }

  function getImageSlides(list) {
    if (!list) return [];
    return Array.prototype.slice.call(list.querySelectorAll('.product__media-item')).filter(function (slide) {
      return !slide.classList.contains('skipp-pdp-gallery-video') && !slide.hasAttribute('data-skipp-clone');
    });
  }

  function getVisibleSlides(list) {
    if (!list) return [];
    var images = getImageSlides(list);
    return images.length > 0 ? images : [];
  }

  function getDesktopPageCount(list) {
    if (!list) return 1;
    var fromSlides = Math.max(1, Math.ceil(getVisibleSlides(list).length / 2));
    var pages = parseInt(getComputedStyle(list).getPropertyValue('--skipp-pdp-pages'), 10);
    if (!Number.isNaN(pages) && pages > fromSlides) return pages;
    return fromSlides;
  }

  function getPageCount(list) {
    return getDesktopPageCount(list);
  }

  function syncDesktopCarouselLayout(host, list) {
    if (!DESKTOP_MQL.matches || !list) return;

    list.querySelectorAll('.skipp-pdp-gallery-video').forEach(function (slide) {
      slide.style.display = 'none';
    });

    var images = getVisibleSlides(list);
    var pages = Math.max(1, Math.ceil(images.length / 2));
    list.style.setProperty('--skipp-pdp-pages', String(pages));
    list.style.setProperty('--skipp-pdp-pages-desktop', String(images.length));
    list.classList.toggle('pdp-image-grid--paged-multi', images.length > 1);
    list.classList.toggle('pdp-image-grid--paged-single', images.length <= 1);

    list.style.removeProperty('display');
    list.style.removeProperty('flex-wrap');
    list.style.removeProperty('grid-template-columns');
    list.style.removeProperty('width');
    list.style.removeProperty('gap');

    images.forEach(function (slide, index) {
      slide.style.display = 'block';
      slide.style.visibility = 'visible';
      slide.style.gridColumn = String(index + 1);
      slide.style.gridRow = '1';
      slide.style.removeProperty('flex');
      slide.style.removeProperty('width');
      slide.style.removeProperty('min-width');
      slide.style.removeProperty('max-width');
    });
  }

  function clearDesktopCarouselLayout(host, list) {
    if (!list) return;
    list.querySelectorAll('.skipp-pdp-gallery-video').forEach(function (slide) {
      slide.style.removeProperty('display');
    });
    getImageSlides(list).forEach(function (slide) {
      slide.style.removeProperty('display');
      slide.style.removeProperty('visibility');
      slide.style.removeProperty('grid-column');
      slide.style.removeProperty('grid-row');
    });
    if (DESKTOP_MQL.matches) {
      syncDesktopCarouselLayout(host, list);
    }
  }

  function getCurrentPage(host, list) {
    var width = host.clientWidth;
    if (width <= 0) return 1;
    return Math.min(getPageCount(list), Math.max(1, Math.round(host.scrollLeft / width) + 1));
  }

  function goToPage(host, list, page, smooth) {
    var pages = getPageCount(list);
    var normalized = ((page - 1) % pages + pages) % pages + 1;
    var left = (normalized - 1) * host.clientWidth;
    if (smooth) {
      host.scrollTo({ left: left, behavior: 'smooth' });
    } else {
      host.scrollLeft = left;
    }
  }

  function getCaretIconMarkup(host) {
    var source = host.querySelector('.slider-button .svg-wrapper');
    return source ? source.innerHTML : '';
  }

  function ensureGalleryNav(host, list, onManualNav) {
    var main = host.closest('.pdp-main');
    if (!main) return null;

    var staleNav = host.querySelector('.skipp-pdp-gallery-nav');
    if (staleNav) staleNav.remove();

    var nav = main.querySelector('.skipp-pdp-gallery-nav');
    if (!nav) {
      var iconMarkup = getCaretIconMarkup(host);
      nav = document.createElement('div');
      nav.className = 'skipp-pdp-gallery-nav';
      nav.innerHTML =
        '<button type="button" class="skipp-pdp-gallery-nav__btn skipp-pdp-gallery-nav__btn--prev" aria-label="Previous images">' +
        '<span class="svg-wrapper">' +
        iconMarkup +
        '</span></button>' +
        '<button type="button" class="skipp-pdp-gallery-nav__btn skipp-pdp-gallery-nav__btn--next" aria-label="Next images">' +
        '<span class="svg-wrapper">' +
        iconMarkup +
        '</span></button>';
      main.appendChild(nav);
    }

    function syncNavLayout() {
      if (!DESKTOP_MQL.matches) {
        nav.style.display = 'none';
        return;
      }
      nav.style.display = 'flex';
      nav.style.top = host.offsetTop + 'px';
      nav.style.left = host.offsetLeft + 'px';
      nav.style.width = host.offsetWidth + 'px';
      nav.style.height = host.offsetHeight + 'px';
    }

    syncNavLayout();

    if (!nav.dataset.skippPdpNavBound) {
      nav.dataset.skippPdpNavBound = '1';

      function navigate(delta) {
        if (!DESKTOP_MQL.matches) return;
        var page = getCurrentPage(host, list) + delta;
        var pages = getPageCount(list);
        if (page < 1) page = pages;
        if (page > pages) page = 1;
        goToPage(host, list, page, false);
        onManualNav();
        syncNavLayout();
      }

      nav.querySelector('.skipp-pdp-gallery-nav__btn--prev').addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        navigate(-1);
      });

      nav.querySelector('.skipp-pdp-gallery-nav__btn--next').addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        navigate(+1);
      });

      if (typeof ResizeObserver !== 'undefined') {
        var layoutObserver = new ResizeObserver(syncNavLayout);
        layoutObserver.observe(host);
        layoutObserver.observe(main);
      }

      window.addEventListener('resize', syncNavLayout);
      DESKTOP_MQL.addEventListener('change', syncNavLayout);
      host.addEventListener('scroll', syncNavLayout);
    } else {
      syncNavLayout();
    }

    return nav;
  }

  function initDesktopGallery(scope) {
    scope.querySelectorAll('.skipp-pdp-premium .pdp-main slider-component.pdp-premium-scroll-host').forEach(function (host) {
      var list = getPagedList(host);
      if (!list || host.dataset.skippDesktopGalleryBound) return;
      host.dataset.skippDesktopGalleryBound = '1';

      function scrollDesktopToActivePage() {
        if (!DESKTOP_MQL.matches) return;
        var images = getVisibleSlides(list);
        if (!images.length) return;
        var active =
          list.querySelector('.product__media-item.is-active:not(.skipp-pdp-gallery-video):not([data-skipp-clone])') ||
          images[0];
        var idx = images.indexOf(active);
        if (idx < 0) idx = 0;
        goToPage(host, list, Math.floor(idx / 2) + 1, false);
      }

      function layoutDesktopCarousel() {
        if (DESKTOP_MQL.matches) {
          syncDesktopCarouselLayout(host, list);
          scrollDesktopToActivePage();
        } else {
          clearDesktopCarouselLayout(host, list);
        }
      }

      var debouncedLayoutDesktopCarousel = debounce(layoutDesktopCarousel, 150);

      layoutDesktopCarousel();
      DESKTOP_MQL.addEventListener('change', layoutDesktopCarousel);
      window.addEventListener('resize', debouncedLayoutDesktopCarousel);

      if (typeof ResizeObserver !== 'undefined') {
        var carouselResizeObserver = new ResizeObserver(debounce(function () {
          if (!DESKTOP_MQL.matches) return;
          if (host.clientWidth > 0) layoutDesktopCarousel();
        }, 150));
        carouselResizeObserver.observe(host);
      }

      requestAnimationFrame(layoutDesktopCarousel);

      if (getPageCount(list) < 2) return;

      var timer = null;
      var dragging = false;
      var dragStartX = 0;
      var dragStartScroll = 0;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function stopAuto() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function startAuto() {
        if (!DESKTOP_MQL.matches || reducedMotion || dragging) return;
        stopAuto();
        timer = setInterval(function () {
          if (!DESKTOP_MQL.matches || dragging) {
            stopAuto();
            return;
          }
          var next = getCurrentPage(host, list) + 1;
          if (next > getPageCount(list)) next = 1;
          goToPage(host, list, next, true);
        }, HOVER_SLIDE_MS);
      }

      function snapToPage(smooth) {
        goToPage(host, list, getCurrentPage(host, list), smooth);
      }

      function onManualNav() {
        stopAuto();
        if (host.matches(':hover')) startAuto();
      }

      ensureGalleryNav(host, list, onManualNav);

      host.addEventListener('mouseenter', startAuto);
      host.addEventListener('mouseleave', function () {
        stopAuto();
        if (dragging) {
          dragging = false;
          host.classList.remove('is-dragging');
        }
      });
      host.addEventListener('focusin', startAuto);
      host.addEventListener('focusout', function (event) {
        if (!host.contains(event.relatedTarget)) stopAuto();
      });

      host.addEventListener('mousedown', function (event) {
        if (!DESKTOP_MQL.matches || event.button !== 0) return;
        if (event.target.closest('.skipp-pdp-gallery-nav, .product__modal-opener, button, a')) return;

        dragging = true;
        dragStartX = event.clientX;
        dragStartScroll = host.scrollLeft;
        host.classList.add('is-dragging');
        stopAuto();
        event.preventDefault();
      });

      window.addEventListener('mousemove', function (event) {
        if (!dragging || !DESKTOP_MQL.matches) return;
        host.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
      });

      window.addEventListener('mouseup', function () {
        if (!dragging) return;
        dragging = false;
        host.classList.remove('is-dragging');
        snapToPage(true);
        if (host.matches(':hover')) startAuto();
      });

      layoutDesktopCarousel();
    });
  }

  function getOriginalHeroSlides(list) {
    return Array.prototype.slice.call(list.querySelectorAll('.product__media-item:not([data-skipp-clone])'));
  }

  function getMobileSlides(list) {
    return Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
  }

  function clonePremiumHeroStrip(list) {
    var originals = getOriginalHeroSlides(list);
    if (originals.length < 2) return false;

    var beforeFragment = document.createDocumentFragment();
    originals.forEach(function (item) {
      var before = item.cloneNode(true);
      before.removeAttribute('id');
      before.dataset.skippClone = '1';
      before.querySelectorAll('[id]').forEach(function (node) {
        node.removeAttribute('id');
      });
      beforeFragment.appendChild(before);
    });
    list.insertBefore(beforeFragment, list.firstChild);

    originals.forEach(function (item) {
      var after = item.cloneNode(true);
      after.removeAttribute('id');
      after.dataset.skippClone = '1';
      after.querySelectorAll('[id]').forEach(function (node) {
        node.removeAttribute('id');
      });
      list.appendChild(after);
    });

    return true;
  }

  function getPremiumHeroLoopMetrics(list) {
    var originals = getOriginalHeroSlides(list);
    if (!originals.length) return null;

    var stride =
      originals.length > 1
        ? originals[1].offsetLeft - originals[0].offsetLeft
        : originals[0].offsetWidth || list.clientWidth;

    return {
      stride: stride,
      setWidth: originals.length * stride,
      middleStart: originals[0].offsetLeft,
    };
  }

  function maybeLoopPremiumHeroScroll(list, metrics, loopState) {
    if (!metrics || loopState.locked || list.dataset.skippProgrammaticScroll === '1') return;

    var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
    var lowerBound = metrics.middleStart - metrics.stride * 0.5;
    var upperBound = metrics.middleStart + metrics.setWidth - list.clientWidth + metrics.stride * 0.5;
    var jumped = false;

    if (list.scrollLeft <= lowerBound) {
      loopState.locked = true;
      list.scrollLeft += metrics.setWidth;
      loopState.locked = false;
      jumped = true;
    } else if (list.scrollLeft >= upperBound || (maxScroll > 0 && list.scrollLeft >= maxScroll - 2)) {
      loopState.locked = true;
      list.scrollLeft -= metrics.setWidth;
      if (list.scrollLeft < 0) list.scrollLeft = 0;
      loopState.locked = false;
      jumped = true;
    }

    if (jumped) {
      list.dataset.skippProgrammaticScroll = '1';
      window.requestAnimationFrame(function () {
        delete list.dataset.skippProgrammaticScroll;
      });
    }
  }

  function ensurePremiumHeroLoop(list) {
    if (!list || !MOBILE_MQL.matches) return null;
    if (list.querySelector('.product__media-item[data-skipp-clone]')) {
      return getPremiumHeroLoopMetrics(list);
    }
    if (getOriginalHeroSlides(list).length < 2) return null;
    var mediaId = getVisibleHeroMediaId(list);
    var metrics = setupPremiumHeroLoop(list);
    list._skippHeroLoopMetrics = metrics;
    if (mediaId) {
      var item = getOriginalHeroItemForMediaId(list, mediaId);
      if (item) scrollHeroSlideIntoView(list, item, false);
    }
    return metrics;
  }

  function setupPremiumHeroLoop(list) {
    if (!clonePremiumHeroStrip(list)) return null;

    var metrics = getPremiumHeroLoopMetrics(list);
    if (!metrics) return null;

    list.dataset.skippMwebNativeScroll = '1';
    list.scrollLeft = metrics.middleStart;
    return metrics;
  }

  function getHeroSlideAtScroll(list) {
    var slides = getMobileSlides(list);
    if (!slides.length) return null;

    var center = list.scrollLeft + list.clientWidth / 2;
    var best = slides[0];
    var bestDist = Infinity;
    slides.forEach(function (slide) {
      var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
      var dist = Math.abs(slideCenter - center);
      if (dist < bestDist) {
        bestDist = dist;
        best = slide;
      }
    });
    return best;
  }

  function scrollHeroSlideIntoView(list, item, smooth) {
    if (!list || !item) return;
    var targetLeft = item.offsetLeft + item.offsetWidth / 2 - list.clientWidth / 2;
    var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
    targetLeft = Math.max(0, Math.min(targetLeft, maxScroll));
    if (smooth) {
      list.scrollTo({ left: targetLeft, behavior: 'smooth' });
    } else {
      list.scrollLeft = targetLeft;
    }
  }

  function getVisibleHeroMediaId(list) {
    var slide = getHeroSlideAtScroll(list);
    if (slide && slide.dataset.mediaId) return slide.dataset.mediaId;
    return getActiveHeroMediaId(list);
  }

  function getBestHeroItemForScroll(list, mediaId) {
    var items = list.querySelectorAll('.product__media-item[data-media-id="' + mediaId + '"]');
    if (!items.length) return null;

    var center = list.scrollLeft + list.clientWidth / 2;
    var best = items[0];
    var bestDist = Infinity;
    items.forEach(function (item) {
      var itemCenter = item.offsetLeft + item.offsetWidth / 2;
      var dist = Math.abs(itemCenter - center);
      if (dist < bestDist) {
        bestDist = dist;
        best = item;
      }
    });
    return best;
  }

  function getActiveHeroMediaId(list) {
    var active = list.querySelector('.product__media-item.is-active:not([data-skipp-clone])');
    if (active && active.dataset.mediaId) return active.dataset.mediaId;
    var originals = getOriginalHeroSlides(list);
    return originals[0] && originals[0].dataset.mediaId ? originals[0].dataset.mediaId : '';
  }

  function updateMobileHeroActiveOnly(list, mediaId) {
    if (!list || !mediaId) return;

    getOriginalHeroSlides(list).forEach(function (slide) {
      slide.classList.toggle('is-active', slide.dataset.mediaId === mediaId);
      slide.classList.remove('is-skipp-mobile-peek');
      slide.classList.toggle('is-skipp-mobile-active', slide.dataset.mediaId === mediaId);
    });
  }

  function applyPremiumMobileHeroState(list, gallery, mediaId) {
    if (!list || !mediaId) return;

    var prevActive = list.querySelector('.product__media-item.is-active:not([data-skipp-clone])');
    var prevId = prevActive && prevActive.dataset.mediaId;

    updateMobileHeroActiveOnly(list, mediaId);

    if (prevId !== mediaId) {
      var canonical = list.querySelector(
        '.product__media-item:not([data-skipp-clone])[data-media-id="' + mediaId + '"]'
      );
      if (gallery && canonical && typeof gallery.playActiveMedia === 'function') {
        gallery.playActiveMedia(canonical);
      }
    }

    var thumbList = gallery && getPremiumThumbList(gallery);
    if (thumbList) syncPremiumThumbsForMedia(thumbList, mediaId);
  }

  function positionHeroToActiveMedia(list, gallery) {
    var mediaId = getActiveHeroMediaId(list);
    if (!mediaId) return;
    scrollHeroToMediaId(list, gallery, mediaId, false);
  }

  function getOriginalHeroItemForMediaId(list, mediaId) {
    if (!list || !mediaId) return null;
    return list.querySelector('.product__media-item:not([data-skipp-clone])[data-media-id="' + mediaId + '"]');
  }

  function scrollHeroToMediaId(list, gallery, mediaId, smooth) {
    if (!list || !mediaId) return;

    markProgrammaticHeroScroll(list, smooth ? 520 : 400);
    var item = getOriginalHeroItemForMediaId(list, mediaId) || getBestHeroItemForScroll(list, mediaId);
    if (item) scrollHeroSlideIntoView(list, item, smooth);

    if (smooth) {
      window.requestAnimationFrame(function () {
        applyPremiumMobileHeroState(list, gallery, mediaId);
      });
      return;
    }

    applyPremiumMobileHeroState(list, gallery, getVisibleHeroMediaId(list));
  }

  function getMobileSlideIndex(list) {
    var slides = getMobileSlides(list);
    if (!slides.length) return 0;

    var scrollLeft = list.scrollLeft;
    var bestIdx = 0;
    var bestDist = Infinity;
    slides.forEach(function (slide, index) {
      var dist = Math.abs(slide.offsetLeft - scrollLeft);
      if (dist < bestDist) {
        bestDist = dist;
        bestIdx = index;
      }
    });
    return bestIdx;
  }

  function syncMobileSliderButtons(list) {
    var host = list.closest('slider-component');
    if (host && typeof host.update === 'function') {
      host.update();
    }
  }

  function resetMobileGalleryScroll(list) {
    list.style.transform = '';
    list.style.transition = '';
    var host = list.closest('slider-component');
    if (host) host.scrollLeft = 0;
  }

  function markProgrammaticHeroScroll(list, ms) {
    if (!list) return;
    list.dataset.skippProgrammaticScroll = '1';
    if (list._skippProgrammaticTimer) window.clearTimeout(list._skippProgrammaticTimer);
    list._skippProgrammaticTimer = window.setTimeout(function () {
      delete list.dataset.skippProgrammaticScroll;
      delete list._skippProgrammaticTimer;
    }, ms || 220);
  }

  function scrollMobileListToIndex(list, index, smooth) {
    var slides = getMobileSlides(list);
    if (!slides.length) return;

    var maxIndex = Math.max(0, slides.length - 1);
    var next = Math.max(0, Math.min(maxIndex, index));
    var target = slides[next];

    list.dataset.skippMobileSlideIndex = String(next);
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-skipp-mobile-active', i === next);
      slide.classList.toggle('is-active', i === next);
      slide.classList.remove('is-skipp-mobile-peek');
    });

    list.classList.toggle('skipp-mweb-no-peek', slides.length < 2 || next >= slides.length - 1);

    if (target) {
      markProgrammaticHeroScroll(list, smooth ? 520 : 220);
      list.scrollTo({
        left: target.offsetLeft,
        behavior: smooth ? 'smooth' : 'auto',
      });
    }

    syncMobileSliderButtons(list);
  }

  function setMobileSlideIndex(list, index) {
    scrollMobileListToIndex(list, index, false);
    resetMobileGalleryScroll(list);
  }

  function syncMobileSlideFromScroll(list, includeThumbs) {
    if (!MOBILE_MQL.matches) return;
    if (list.dataset.skippProgrammaticScroll === '1' && !includeThumbs) return;

    var slide = getHeroSlideAtScroll(list);
    if (!slide || !slide.dataset.mediaId) return;

    var mediaId = slide.dataset.mediaId;
    if (includeThumbs) {
      applyPremiumMobileHeroState(list, list.closest('media-gallery'), mediaId);
      return;
    }

    var prevActive = list.querySelector('.product__media-item.is-active:not([data-skipp-clone])');
    if (prevActive && prevActive.dataset.mediaId === mediaId) return;

    updateMobileHeroActiveOnly(list, mediaId);
  }

  function settleMobileHeroScroll(list) {
    if (!MOBILE_MQL.matches) return;

    var metrics = list._skippHeroLoopMetrics;
    var loopState = list._skippHeroLoopState;
    if (metrics && loopState && list.dataset.skippProgrammaticScroll !== '1') {
      maybeLoopPremiumHeroScroll(list, metrics, loopState);
    }

    var mediaId = getVisibleHeroMediaId(list);
    if (!mediaId) return;
    applyPremiumMobileHeroState(list, list.closest('media-gallery'), mediaId);
  }

  function getInitialMobileSlideIndex(list) {
    var slides = getMobileSlides(list);
    if (!slides.length) return 0;

    var activeIdx = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (activeIdx >= 0) return activeIdx;

    if (list.dataset.skippMobileSlideIndex) {
      var parsed = parseInt(list.dataset.skippMobileSlideIndex, 10);
      if (!Number.isNaN(parsed)) return Math.max(0, Math.min(slides.length - 1, parsed));
    }

    return 0;
  }

  function bindMobileVerticalScrollPassthrough(list) {
    if (list.dataset.skippVerticalPassthroughBound) return;
    list.dataset.skippVerticalPassthroughBound = '1';

    var host = list.closest('slider-component');
    var startX = 0;
    var startY = 0;
    var axis = null;

    function setScrollIntent(mode) {
      var vertical = mode === 'vertical';
      var horizontal = mode === 'horizontal';
      list.classList.toggle('skipp-mweb-scroll-vertical', vertical);
      list.classList.toggle('skipp-mweb-scroll-horizontal', horizontal);
      if (host) {
        host.classList.toggle('skipp-mweb-scroll-vertical', vertical);
        host.classList.toggle('skipp-mweb-scroll-horizontal', horizontal);
      }
    }

    function resetPassthrough() {
      axis = null;
      setScrollIntent(null);
    }

    list.addEventListener(
      'touchstart',
      function (event) {
        if (!MOBILE_MQL.matches || event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        axis = null;
        setScrollIntent(null);
      },
      { passive: true }
    );

    list.addEventListener(
      'touchmove',
      function (event) {
        if (!MOBILE_MQL.matches || event.touches.length !== 1) return;

        var dx = event.touches[0].clientX - startX;
        var dy = event.touches[0].clientY - startY;

        if (!axis && (Math.abs(dx) > 4 || Math.abs(dy) > 4)) {
          axis = Math.abs(dy) > Math.abs(dx) * 0.85 ? 'vertical' : 'horizontal';
          setScrollIntent(axis);
          if (axis === 'horizontal') ensurePremiumHeroLoop(list);
        }
      },
      { passive: true }
    );

    list.addEventListener('touchend', resetPassthrough, { passive: true });
    list.addEventListener('touchcancel', resetPassthrough, { passive: true });

    MOBILE_MQL.addEventListener('change', function () {
      if (!MOBILE_MQL.matches) resetPassthrough();
    });
  }

  function bindMobileGalleryScroll(list) {
    if (list.dataset.skippGalleryScrollBound) return;
    list.dataset.skippGalleryScrollBound = '1';

    var scrollTimer = null;
    var loopState = { locked: false };
    var metrics = null;

    list._skippHeroLoopState = loopState;
    list._skippRefreshHeroLoopMetrics = function () {
      var metrics = list.querySelector('.product__media-item[data-skipp-clone]')
        ? getPremiumHeroLoopMetrics(list)
        : null;
      list._skippHeroLoopMetrics = metrics;
      return metrics;
    };

    list._skippGoToMedia = function (mediaId, smooth) {
      scrollHeroToMediaId(list, list.closest('media-gallery'), mediaId, smooth);
    };

    list.addEventListener(
      'touchstart',
      function () {
        delete list.dataset.skippProgrammaticScroll;
      },
      { passive: true }
    );

    list.addEventListener(
      'scroll',
      function () {
        if (!MOBILE_MQL.matches) return;
        if (scrollTimer) window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          syncMobileSlideFromScroll(list, false);
        }, MOBILE_SCROLL_SYNC_MS);
      },
      { passive: true }
    );

    list.addEventListener(
      'scrollend',
      function () {
        if (!MOBILE_MQL.matches) return;
        if (scrollTimer) window.clearTimeout(scrollTimer);
        settleMobileHeroScroll(list);
      },
      { passive: true }
    );
  }

  function initMobileGalleryScroll(scope) {
    scope.querySelectorAll('.skipp-pdp-premium .pdp-main ul.pdp-image-grid--paged').forEach(function (list) {
      if (list.dataset.skippTouchScrollBound) return;
      list.dataset.skippTouchScrollBound = '1';

      list.dataset.skippMwebNativeScroll = '1';
      lockMobileHeroGallery(list);
      bindMobileVerticalScrollPassthrough(list);
      bindMobileGalleryScroll(list);
      list._skippMarkProgrammaticScroll = function (ms) {
        markProgrammaticHeroScroll(list, ms);
      };

      MOBILE_MQL.addEventListener('change', function () {
        if (!MOBILE_MQL.matches) {
          list.style.transform = '';
          list.style.transition = '';
          list.classList.remove('skipp-mweb-no-peek');
          delete list.dataset.skippMobileSlideIndex;
          list.querySelectorAll('.product__media-item.is-skipp-mobile-active, .product__media-item.is-skipp-mobile-peek').forEach(function (slide) {
            slide.classList.remove('is-skipp-mobile-active', 'is-skipp-mobile-peek');
          });
        }
      });
    });
  }

  function lockMobileHeroGallery(list) {
    var originals = getOriginalHeroSlides(list);
    if (!originals.length) return;

    var activeIdx = originals.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (activeIdx < 0) activeIdx = 0;

    originals.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === activeIdx);
      slide.classList.remove('is-skipp-mobile-active', 'is-skipp-mobile-peek', 'scroll-trigger--offscreen');
      slide.classList.add('scroll-trigger--cancel');
    });
  }

  function getCenterThumbItem(list) {
    if (!list) return null;
    var listRect = list.getBoundingClientRect();
    var centerX = listRect.left + listRect.width / 2;
    var items = list.querySelectorAll('.thumbnail-list__item');
    var closest = null;
    var closestDist = Infinity;

    items.forEach(function (item) {
      var rect = item.getBoundingClientRect();
      var dist = Math.abs(rect.left + rect.width / 2 - centerX);
      if (dist < closestDist) {
        closestDist = dist;
        closest = item;
      }
    });

    return closest;
  }

  function pinThumbScaleToItem(list, centerItem) {
    if (!list) return;
    list.querySelectorAll('.thumbnail-list__item').forEach(function (item) {
      var isCenter = !!centerItem && item === centerItem;
      item.classList.toggle('is-skipp-thumb-center', isCenter);
      item.classList.toggle('is-skipp-thumb-side', !isCenter);
    });
  }

  function pinThumbScaleToViewportCenter(list) {
    pinThumbScaleToItem(list, getCenterThumbItem(list));
  }

  function isThumbMediaViewportCentered(list, mediaId) {
    var center = getCenterThumbItem(list);
    return !!(center && center.dataset.target === mediaId);
  }

  function markPremiumThumbActive(thumbList, mediaId) {
    if (!thumbList || !mediaId) return;
    thumbList.querySelectorAll('.thumbnail-list__item:not([data-skipp-clone])').forEach(function (item) {
      item.classList.toggle('is-skipp-thumb-active', item.dataset.target === mediaId);
    });
  }

  function syncPremiumThumbsForMedia(thumbList, mediaId, options) {
    if (!thumbList || !mediaId) return;
    options = options || {};

    thumbList.dataset.skippActiveThumbMedia = mediaId;
    setThumbAriaForMedia(thumbList, mediaId);
    markPremiumThumbActive(thumbList, mediaId);

    var item = thumbList.querySelector(
      '.thumbnail-list__item:not([data-skipp-clone])[data-target="' + mediaId + '"]'
    );
    if (item && typeof item.scrollIntoView === 'function') {
      item.scrollIntoView({
        inline: 'nearest',
        block: 'nearest',
        behavior: options.init ? 'auto' : 'smooth',
      });
    }
  }

  function setThumbAriaForMedia(list, mediaId) {
    if (!list || !mediaId) return;
    list.querySelectorAll('button.thumbnail').forEach(function (btn) {
      btn.removeAttribute('aria-current');
    });
    list.querySelectorAll('[data-target="' + mediaId + '"] button.thumbnail').forEach(function (btn) {
      btn.setAttribute('aria-current', 'true');
    });
  }

  function getActiveMainMediaId(gallery) {
    if (!gallery) return '';
    var hero = gallery.querySelector('ul.pdp-image-grid--paged');
    if (!hero) return '';
    var active = hero.querySelector('.product__media-item.is-active');
    return active && active.dataset.mediaId ? active.dataset.mediaId : '';
  }

  function getPremiumThumbList(gallery) {
    if (!gallery) return null;
    return (
      gallery.querySelector('.product-thumbnails--strip .skipp-pdp-thumb-strip') ||
      gallery.querySelector('.product-thumbnails--overlay .skipp-pdp-thumb-carousel')
    );
  }

  function markThumbDriven(list) {
    if (!list) return;
    list.classList.add('is-skipp-thumb-driven');
    if (list._skippThumbDrivenTimer) window.clearTimeout(list._skippThumbDrivenTimer);
    list._skippThumbDrivenTimer = window.setTimeout(function () {
      list.classList.remove('is-skipp-thumb-driven');
      delete list._skippThumbDrivenTimer;
    }, 120);
  }

  function centerThumbToMediaId(list, mediaId, metrics, loopState) {
    syncPremiumThumbsForMedia(list, mediaId);
  }

  function cancelThumbAnimations(list) {
    if (!list) return;
    stopThumbScaleTracking(list);
    list._skippAnimGen = (list._skippAnimGen || 0) + 1;
    if (list._skippHeroThumbTimer) {
      window.clearTimeout(list._skippHeroThumbTimer);
      delete list._skippHeroThumbTimer;
    }
    list.classList.remove('is-skipp-thumb-settling');
  }

  function updatePremiumThumbVisualScale(list) {
    if (!list || list.dataset.skippHeroNavLock || list.dataset.skippThumbScrollLock) return;
    if (list.dataset.skippActiveThumbMedia && !list.dataset.skippThumbUserScroll) {
      var item = getBestThumbItemForScroll(list, list.dataset.skippActiveThumbMedia, null);
      pinThumbScaleToItem(list, item);
      return;
    }
    pinThumbScaleToViewportCenter(list);
  }

  function schedulePremiumThumbVisualScale(list) {
    if (!list || list._skippScaleRaf) return;
    list._skippScaleRaf = window.requestAnimationFrame(function () {
      delete list._skippScaleRaf;
      updatePremiumThumbVisualScale(list);
    });
  }

  function stopThumbScaleTracking(list) {
    if (list && list._skippSettleRaf) {
      window.cancelAnimationFrame(list._skippSettleRaf);
      delete list._skippSettleRaf;
    }
  }

  function trackThumbScaleUntilSettled(list, callback, maxMs) {
    if (!list) return;
    maxMs = maxMs || THUMB_ANIM_MS + 80;
    stopThumbScaleTracking(list);

    var gen = list._skippAnimGen || 0;
    var started = Date.now();
    var lastLeft = list.scrollLeft;
    var stillFrames = 0;

    list.classList.add('is-skipp-thumb-settling');

    function tick() {
      if (list._skippAnimGen !== gen || list.dataset.skippHeroNavLock) {
        delete list._skippSettleRaf;
        list.classList.remove('is-skipp-thumb-settling');
        return;
      }

      updatePremiumThumbVisualScale(list);
      var currentLeft = list.scrollLeft;
      if (currentLeft === lastLeft) stillFrames += 1;
      else {
        stillFrames = 0;
        lastLeft = currentLeft;
      }

      if (stillFrames >= 5 || Date.now() - started > maxMs) {
        delete list._skippSettleRaf;
        list.classList.remove('is-skipp-thumb-settling');
        if (list._skippAnimGen === gen) updatePremiumThumbVisualScale(list);
        if (typeof callback === 'function' && list._skippAnimGen === gen) callback();
        return;
      }

      list._skippSettleRaf = window.requestAnimationFrame(tick);
    }

    list._skippSettleRaf = window.requestAnimationFrame(tick);
  }

  function animateThumbToItem(list, item, callback) {
    if (!list || !item) return;
    if (list.dataset.skippHeroNavLock) return;

    var gen = (list._skippAnimGen || 0) + 1;
    list._skippAnimGen = gen;
    cancelThumbAnimations(list);
    list._skippAnimGen = gen;

    list.dataset.skippThumbScrollLock = '1';
    updatePremiumThumbVisualScale(list);
    scrollPremiumThumbIntoCenter(list, item, true);
    trackThumbScaleUntilSettled(list, function () {
      if (list._skippAnimGen !== gen) return;
      delete list.dataset.skippThumbScrollLock;
      if (typeof callback === 'function') callback();
    });
  }

  function isThumbScrollLocked(list) {
    return !!(list && list.dataset.skippThumbScrollLock);
  }

  function getBestThumbItemForScroll(list, mediaId, preferredItem) {
    if (preferredItem && preferredItem.dataset.target === mediaId) return preferredItem;

    var items = list.querySelectorAll('[data-target="' + mediaId + '"]');
    if (!items.length) return preferredItem;

    var listRect = list.getBoundingClientRect();
    var centerX = listRect.left + listRect.width / 2;
    var best = items[0];
    var bestDist = Infinity;
    items.forEach(function (item) {
      var rect = item.getBoundingClientRect();
      var dist = Math.abs(rect.left + rect.width / 2 - centerX);
      if (dist < bestDist) {
        bestDist = dist;
        best = item;
      }
    });
    return best;
  }

  function centerThumbForMedia(list, mediaId, smooth) {
    if (!list || !mediaId) return;
    if (list.dataset.skippHeroNavLock) return;

    var scrollItem = getBestThumbItemForScroll(list, mediaId, null);
    if (!scrollItem) return;

    if (smooth === true) {
      animateThumbToItem(list, scrollItem, function () {
        updatePremiumThumbVisualScale(list);
      });
      return;
    }

    list.dataset.skippThumbScrollLock = '1';
    scrollPremiumThumbIntoCenter(list, scrollItem, false);
    updatePremiumThumbVisualScale(list);
    window.requestAnimationFrame(function () {
      delete list.dataset.skippThumbScrollLock;
    });
  }

  function selectPremiumThumb(list, gallery, mediaId) {
    if (!list || !gallery || !mediaId) return;

    cancelThumbAnimations(list);
    delete list.dataset.skippHeroNavLock;
    delete list.dataset.skippPendingHeroMedia;
    list.classList.remove('is-skipp-hero-nav');

    var heroList = gallery.querySelector('ul.pdp-image-grid--paged');
    if (heroList) scrollHeroToMediaId(heroList, gallery, mediaId, false);
  }

  function setupPremiumThumbLoop(list) {
    if (!clonePremiumThumbStrip(list)) return null;

    var metrics = getPremiumThumbLoopMetrics(list);
    if (!metrics) return null;

    list.scrollLeft = metrics.middleStart;
    return metrics;
  }

  var CITY_TAG_SLUG_ALIASES = [
    ['bangalore', 'bengaluru', 'blr'],
    ['mumbai', 'bombay', 'bom']
  ];

  function parseProductTags(tagsInput) {
    if (tagsInput == null) return [];
    if (Array.isArray(tagsInput)) {
      return tagsInput.map(function (t) {
        return String(t).trim().toLowerCase();
      }).filter(Boolean);
    }
    var s = String(tagsInput).trim();
    if (!s) return [];
    try {
      var parsed = JSON.parse(s);
      if (Array.isArray(parsed)) {
        return parsed.map(function (t) {
          return String(t).trim().toLowerCase();
        }).filter(Boolean);
      }
    } catch (_e) {
      /* comma-separated */
    }
    return s.split(',').map(function (t) {
      return t.trim().toLowerCase();
    }).filter(Boolean);
  }

  function addSlugVariants(set, value) {
    if (!value) return;
    set.add(value);
    set.add(value.replace(/_/g, '-'));
    set.add(value.replace(/-/g, '_'));
  }

  function expandAliasGroups(set) {
    var out = new Set(set);
    set.forEach(function (value) {
      CITY_TAG_SLUG_ALIASES.forEach(function (group) {
        if (group.indexOf(value) !== -1) {
          group.forEach(function (g) {
            out.add(g);
          });
        }
      });
    });
    return out;
  }

  function slugifyCity(city) {
    return String(city || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/gi, '');
  }

  function getUserCitySlugCandidates(userCity) {
    var city = String(userCity || '').trim();
    if (!city) return new Set();

    var cityLower = city.toLowerCase();
    var raw = new Set();
    var slug = slugifyCity(city).replace(/-/g, '_');
    if (slug) raw.add(slug);
    raw.add(cityLower.replace(/\s+/g, '_').replace(/[^a-z0-9_-]/g, ''));
    raw.add(cityLower.replace(/\s+/g, '-').replace(/[^a-z0-9_-]/g, ''));
    raw.add(cityLower.replace(/\s+/g, '').replace(/[^a-z0-9]/g, ''));

    var normalized = new Set();
    raw.forEach(function (s) {
      if (s) addSlugVariants(normalized, s);
    });
    return expandAliasGroups(normalized);
  }

  function getProductCities(productTags) {
    return parseProductTags(productTags)
      .filter(function (tag) {
        return tag.indexOf('city_') === 0;
      })
      .map(function (tag) {
        return tag.slice(5);
      })
      .filter(Boolean);
  }

  function productCitiesMatchUser(productCitySuffixes, userCity) {
    if (!productCitySuffixes.length) return false;
    var userCandidates = getUserCitySlugCandidates(userCity);
    if (!userCandidates.size) return false;

    var productSet = new Set();
    productCitySuffixes.forEach(function (suffix) {
      addSlugVariants(productSet, suffix);
    });
    var productExpanded = expandAliasGroups(productSet);

    var matched = false;
    userCandidates.forEach(function (u) {
      if (productExpanded.has(u)) matched = true;
    });
    return matched;
  }

  /**
   * 30 min: product has `express` + `city_<name>` and user's city matches a city tag.
   * 2 days: user city differs, or product lacks express / city tags, or location unknown.
   */
  function isExpressDeliveryForUser(productTags, userCity) {
    var tags = parseProductTags(productTags);
    var city = String(userCity || '').trim();
    if (!city || tags.indexOf('express') === -1) return false;

    var productCities = getProductCities(productTags);
    if (!productCities.length) return false;

    return productCitiesMatchUser(productCities, city);
  }

  function resolvePdpDeliveryMessage(productTags, city) {
    var EXPRESS_MSG = 'Delivery in 30 mins';
    var STANDARD_MSG = 'Delivery within 2 days';

    if (isExpressDeliveryForUser(productTags, city)) {
      return { mode: 'express', text: EXPRESS_MSG };
    }

    return { mode: 'standard', text: STANDARD_MSG };
  }

  function updatePdpDeliveryEta(scope) {
    var root = scope && scope.querySelector ? scope : document;
    root.querySelectorAll('[data-skipp-pdp-delivery-eta]').forEach(function (el) {
      var tags = el.getAttribute('data-product-tags') || '';
      var city = '';
      if (window.SkippUserLocation && typeof window.SkippUserLocation.getUserLocation === 'function') {
        var loc = window.SkippUserLocation.getUserLocation();
        city = (loc && loc.city) || '';
      }
      var result = resolvePdpDeliveryMessage(tags, city);
      var textEl = el.querySelector('[data-skipp-pdp-delivery-text]');
      if (textEl) textEl.textContent = result.text;
      el.classList.toggle('skipp-pdp-delivery-eta--express', result.mode === 'express');
      el.classList.toggle('skipp-pdp-delivery-eta--standard', result.mode === 'standard');
      el.classList.remove('skipp-pdp-delivery-eta--unknown');
    });
  }

  function appendSpecCell(grid, key, value) {
    var cell = document.createElement('div');
    cell.className = 'skipp-pdp-spec-cell';
    var kEl = document.createElement('span');
    kEl.className = 'skipp-pdp-spec-k';
    kEl.textContent = key;
    var vEl = document.createElement('span');
    vEl.className = 'skipp-pdp-spec-v';
    vEl.textContent = value;
    cell.appendChild(kEl);
    cell.appendChild(vEl);
    grid.appendChild(cell);
  }

  function normalizeSpecKey(key) {
    return String(key || '')
      .trim()
      .replace(/:$/, '')
      .toLowerCase();
  }

  function gridHasSpecKey(grid, key) {
    var needle = normalizeSpecKey(key);
    if (!needle) return false;
    return Array.prototype.some.call(grid.querySelectorAll('.skipp-pdp-spec-k'), function (el) {
      return normalizeSpecKey(el.textContent) === needle;
    });
  }

  function parseSpecPairs(container) {
    var items = [];

    container.querySelectorAll('table tr').forEach(function (row) {
      var cells = row.querySelectorAll('th, td');
      if (cells.length < 2) return;
      var k = cells[0].textContent.trim();
      var v = cells[1].textContent.trim();
      if (k && v) items.push({ k: k, v: v });
    });
    if (items.length >= 2) return items;

    container.querySelectorAll('dl').forEach(function (dl) {
      var dts = dl.querySelectorAll('dt');
      dts.forEach(function (dt, index) {
        var dd = dt.nextElementSibling;
        if (!dd || dd.tagName !== 'DD') return;
        var k = dt.textContent.trim();
        var v = dd.textContent.trim();
        if (k && v) items.push({ k: k, v: v });
      });
    });
    if (items.length >= 2) return items;

    container.querySelectorAll('ul > li, ol > li').forEach(function (li) {
      var text = li.textContent.trim();
      if (!text || text.length > 120) return;
      var colon = text.indexOf(':');
      if (colon > 0 && colon < 40) {
        items.push({ k: text.slice(0, colon).trim(), v: text.slice(colon + 1).trim() });
        return;
      }
      var lines = text
        .split('\n')
        .map(function (line) {
          return line.trim();
        })
        .filter(Boolean);
      if (lines.length >= 2 && lines[0].length < 40) {
        items.push({ k: lines[0].replace(/:$/, ''), v: lines.slice(1).join(' ') });
      }
    });
    if (items.length >= 2) return items;

    container.querySelectorAll(':scope > p').forEach(function (p) {
      var text = p.textContent.trim();
      if (!text || text.length > 140) return;

      var strong = p.querySelector('strong, b');
      if (strong) {
        var kStrong = strong.textContent.trim().replace(/:$/, '');
        var clone = p.cloneNode(true);
        Array.prototype.forEach.call(clone.querySelectorAll('strong, b'), function (el) {
          el.remove();
        });
        var vStrong = clone.textContent.trim();
        if (kStrong && vStrong) items.push({ k: kStrong, v: vStrong });
        return;
      }

      var parts = p.innerHTML.split(/<br\s*\/?>/i);
      if (parts.length >= 2) {
        var kPart = parts[0].replace(/<[^>]+>/g, '').trim().replace(/:$/, '');
        var vPart = parts
          .slice(1)
          .join(' ')
          .replace(/<[^>]+>/g, '')
          .trim();
        if (kPart && vPart && kPart.length < 50) items.push({ k: kPart, v: vPart });
        return;
      }

      var colon = text.indexOf(':');
      if (colon > 0 && colon < 40) {
        items.push({ k: text.slice(0, colon).trim(), v: text.slice(colon + 1).trim() });
      }
    });

    return items.length >= 2 ? items : null;
  }

  function isBodyDescription(container) {
    if (container.querySelector('img, iframe, video')) return true;

    var ps = container.querySelectorAll(':scope > p');
    if (!ps.length) {
      return container.textContent.trim().length > 280;
    }

    var longCount = 0;
    ps.forEach(function (p) {
      if (p.textContent.trim().length > 140) longCount++;
    });

    if (longCount >= 2) return true;
    if (ps.length === 1 && ps[0].textContent.trim().length > 220) return true;

    var specCandidates = parseSpecPairs(container);
    if (specCandidates && specCandidates.length >= 2 && longCount === 0) return false;

    if (longCount > 0 && (!specCandidates || specCandidates.length < 2)) return true;

    return container.textContent.trim().length > 500 && (!specCandidates || specCandidates.length < 3);
  }

  function initPdpDetailsGrid(scope) {
    var root = scope && scope.querySelector ? scope : document;
    root.querySelectorAll('.skipp-pdp-details-root').forEach(function (detailsRoot) {
      if (detailsRoot.dataset.skippDetailsGridBound) return;
      detailsRoot.dataset.skippDetailsGridBound = '1';

      var grid = detailsRoot.querySelector('[data-skipp-pdp-specs-grid]');
      var desc = detailsRoot.querySelector('[data-skipp-pdp-desc-source]');
      if (!grid) return;

      if (!desc) return;

      if (isBodyDescription(desc)) {
        desc.classList.add('skipp-pdp-desc--body');
        return;
      }

      var pairs = parseSpecPairs(desc);
      if (!pairs || pairs.length < 2) {
        desc.classList.add('skipp-pdp-desc--body');
        return;
      }

      pairs.forEach(function (pair) {
        if (gridHasSpecKey(grid, pair.k)) return;
        appendSpecCell(grid, pair.k, pair.v);
      });

      desc.remove();
    });
  }

  function initPdpDeliveryEta(scope) {
    updatePdpDeliveryEta(scope);
    if (document.documentElement.dataset.skippPdpDeliveryBound) return;
    document.documentElement.dataset.skippPdpDeliveryBound = '1';

    document.addEventListener('skipp:user-location-changed', function () {
      updatePdpDeliveryEta(document);
    });
    document.addEventListener('locationUpdated', function () {
      updatePdpDeliveryEta(document);
    });
    document.addEventListener('skipp:city-changed', function () {
      updatePdpDeliveryEta(document);
    });
    document.addEventListener('skipp:location-api-ready', function () {
      updatePdpDeliveryEta(document);
    });
  }

  function getPdpSectionRoot(sectionId) {
    return document.getElementById('MainProduct-' + sectionId) || document;
  }

  function getPdpSubmitButton(sectionId) {
    var root = getPdpSectionRoot(sectionId);
    return (
      root.querySelector('#ProductSubmitButton-' + sectionId) ||
      document.getElementById('ProductSubmitButton-' + sectionId)
    );
  }

  function getPdpCartForm(sectionId) {
    var root = getPdpSectionRoot(sectionId);
    var productForm = root.querySelector('product-form[data-section-id="' + sectionId + '"]');
    return productForm ? productForm.querySelector('form[data-type="add-to-cart-form"]') : null;
  }

  function submitPdpAddToCart(sectionId) {
    var addBtn = getPdpSubmitButton(sectionId);
    if (!addBtn || addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') return false;

    var form = getPdpCartForm(sectionId);
    if (form && typeof form.requestSubmit === 'function') {
      form.requestSubmit(addBtn);
      return true;
    }

    addBtn.click();
    return true;
  }

  function placeRazorpayBuyButton() {
    var magic = document.querySelector('.magic-buy-btn__parent');
    var formButtons = document.querySelector('.skipp-pdp-premium .product-form__buttons');
    if (magic && formButtons && magic.parentElement !== formButtons) formButtons.appendChild(magic);
    document.body.style.removeProperty('--skipp-pdp-sticky-height');
  }

  function syncStickyPurchaseBar(scope) {
    var sticky = scope.querySelector('[data-skipp-pdp-sticky]');
    if (!sticky) return;

    var sectionId = sticky.getAttribute('data-section-id');
    if (!sectionId) return;

    var stickyAdd = sticky.querySelector('[data-skipp-sticky-add]');
    var stickyBuy = sticky.querySelector('[data-skipp-sticky-buy-now]');

    function sync() {
      placeRazorpayBuyButton();
      var addBtn = getPdpSubmitButton(sectionId);
      var buyBtn = getPdpSectionRoot(sectionId).querySelector('#flo-buy-now-button') || document.getElementById('flo-buy-now-button');

      if (stickyAdd && addBtn) {
        stickyAdd.disabled = addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true';
        var label = addBtn.querySelector('span');
        if (label && label.textContent) {
          stickyAdd.textContent = label.textContent.trim();
        }
      }

      if (stickyBuy) {
        if (document.querySelector('.magic-buy-btn__parent') || !buyBtn || buyBtn.offsetParent === null) {
          stickyBuy.hidden = true;
          stickyBuy.disabled = true;
        } else {
          stickyBuy.hidden = false;
          stickyBuy.disabled = buyBtn.disabled;
        }
      }
    }

    if (!sticky.dataset.skippStickyBound) {
      sticky.dataset.skippStickyBound = '1';

      stickyAdd?.addEventListener('click', function (event) {
        event.preventDefault();
        submitPdpAddToCart(sectionId);
      });

      stickyBuy?.addEventListener('click', function (event) {
        event.preventDefault();
        var buyBtn =
          getPdpSectionRoot(sectionId).querySelector('#flo-buy-now-button') ||
          document.getElementById('flo-buy-now-button');
        if (buyBtn && !buyBtn.disabled) buyBtn.click();
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          if (event && event.data && String(event.data.sectionId) !== String(sectionId)) return;
          requestAnimationFrame(sync);
        });
      }

      var productInfo = scope.querySelector('product-info') || document.querySelector('product-info');
      productInfo?.addEventListener('product-info:loaded', sync);

      if (!document.documentElement.dataset.skippMagicBuyWatch) {
        document.documentElement.dataset.skippMagicBuyWatch = '1';
        var watchRoot = document.querySelector('.skipp-pdp-buy-actions') || document.body;
        new MutationObserver(function () {
          placeRazorpayBuyButton();
        }).observe(watchRoot, { childList: true, subtree: true });
        window.addEventListener('resize', placeRazorpayBuyButton);
      }
    }

    sync();
  }

  function scrollPremiumThumbIntoCenter(list, item, smooth) {
    if (!list || !item) return;
    var listRect = list.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    var delta = itemRect.left + itemRect.width / 2 - (listRect.left + listRect.width / 2);
    list.scrollBy({ left: delta, behavior: smooth ? 'smooth' : 'auto' });
  }

  function getActiveThumbTarget(list) {
    var activeBtn =
      list.querySelector('.thumbnail-list__item:not([data-skipp-clone]) .thumbnail[aria-current="true"]') ||
      list.querySelector('.thumbnail[aria-current="true"]');
    if (!activeBtn) return '';
    var item = activeBtn.closest('[data-target]');
    return item ? item.dataset.target || '' : '';
  }

  function clonePremiumThumbStrip(list) {
    var originals = Array.from(list.querySelectorAll('.thumbnail-list__item:not([data-skipp-clone])'));
    if (originals.length < 2) return false;

    var beforeFragment = document.createDocumentFragment();
    originals.forEach(function (item) {
      var before = item.cloneNode(true);
      before.removeAttribute('id');
      before.dataset.skippClone = '1';
      before.classList.remove('is-skipp-thumb-center');
      before.classList.add('is-skipp-thumb-side');
      before.querySelectorAll('[id]').forEach(function (node) {
        node.removeAttribute('id');
      });
      beforeFragment.appendChild(before);
    });
    list.insertBefore(beforeFragment, list.firstChild);

    originals.forEach(function (item) {
      var after = item.cloneNode(true);
      after.removeAttribute('id');
      after.dataset.skippClone = '1';
      after.classList.remove('is-skipp-thumb-center');
      after.classList.add('is-skipp-thumb-side');
      after.querySelectorAll('[id]').forEach(function (node) {
        node.removeAttribute('id');
      });
      list.appendChild(after);
    });

    return true;
  }

  function getPremiumThumbLoopMetrics(list) {
    var originals = list.querySelectorAll('.thumbnail-list__item:not([data-skipp-clone])');
    if (!originals.length) return null;

    var stride =
      originals.length > 1
        ? originals[1].offsetLeft - originals[0].offsetLeft
        : originals[0].offsetWidth + parseFloat(getComputedStyle(list).gap || '0') || originals[0].offsetWidth;

    return {
      stride: stride,
      setWidth: originals.length * stride,
      middleStart: originals[0].offsetLeft,
    };
  }

  function maybeLoopPremiumThumbScroll(list, metrics, loopState) {
    if (!metrics || loopState.locked || list.dataset.skippThumbScrollLock) return;

    var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
    var lowerBound = metrics.middleStart - metrics.stride * 0.5;
    var upperBound = metrics.middleStart + metrics.setWidth - list.clientWidth + metrics.stride * 0.5;
    var jumped = false;

    if (list.scrollLeft <= lowerBound) {
      loopState.locked = true;
      list.scrollLeft += metrics.setWidth;
      loopState.locked = false;
      jumped = true;
    } else if (list.scrollLeft >= upperBound || (maxScroll > 0 && list.scrollLeft >= maxScroll - 2)) {
      loopState.locked = true;
      list.scrollLeft -= metrics.setWidth;
      if (list.scrollLeft < 0) list.scrollLeft = 0;
      loopState.locked = false;
      jumped = true;
    }

    if (jumped) {
      list.dataset.skippThumbScrollLock = '1';
      window.requestAnimationFrame(function () {
        delete list.dataset.skippThumbScrollLock;
      });
    }
  }

  function onPremiumThumbScrollSettled(list, metrics, loopState) {
    if (!list || list.dataset.skippThumbScrollLock || list.dataset.skippHeroNavLock) return;
    if (metrics) maybeLoopPremiumThumbScroll(list, metrics, loopState);

    if (list.dataset.skippThumbUserScroll) {
      var centered = getCenterThumbItem(list);
      if (centered && centered.dataset.target) {
        list.dataset.skippActiveThumbMedia = centered.dataset.target;
        setThumbAriaForMedia(list, centered.dataset.target);
      }
      pinThumbScaleToViewportCenter(list);
      delete list.dataset.skippThumbUserScroll;
      return;
    }

    if (list.dataset.skippActiveThumbMedia) {
      var item = getBestThumbItemForScroll(list, list.dataset.skippActiveThumbMedia, null);
      if (item) {
        pinThumbScaleToItem(list, item);
        return;
      }
    }

    pinThumbScaleToViewportCenter(list);
  }

  function seedPremiumThumbScaleClasses(list) {
    if (!list) return;
    list.querySelectorAll('.thumbnail-list__item:not([data-skipp-clone])').forEach(function (item) {
      var isActive = item.querySelector('.thumbnail[aria-current="true"]');
      item.classList.toggle('is-skipp-thumb-center', !!isActive);
      item.classList.toggle('is-skipp-thumb-side', !isActive);
    });
  }

  function bootstrapPremiumMobileGallery(gallery) {
    if (!MOBILE_MQL.matches || !gallery || gallery.dataset.skippMwebGalleryReady === '1') return;

    var hero = gallery.querySelector('ul.pdp-image-grid--paged');
    if (!hero) return;

    var thumbList = getPremiumThumbList(gallery);
    var thumbWrap = thumbList && thumbList.closest('.product-thumbnails--strip, .product-thumbnails--overlay');
    var mediaId = getActiveHeroMediaId(hero);
    if (!mediaId) return;

    if (!hero._skippHeroLoopState) hero._skippHeroLoopState = { locked: false };
    hero._skippHeroLoopMetrics = null;

    markProgrammaticHeroScroll(hero, 400);
    var heroItem = getOriginalHeroItemForMediaId(hero, mediaId);
    if (heroItem) scrollHeroSlideIntoView(hero, heroItem, false);

    mediaId = getVisibleHeroMediaId(hero) || mediaId;
    updateMobileHeroActiveOnly(hero, mediaId);

    var canonical = hero.querySelector(
      '.product__media-item:not([data-skipp-clone])[data-media-id="' + mediaId + '"]'
    );
    if (canonical && typeof gallery.playActiveMedia === 'function') {
      gallery.playActiveMedia(canonical);
    }

    if (thumbList) {
      syncPremiumThumbsForMedia(thumbList, mediaId, { init: true });
      thumbList.dataset.skippThumbReady = '1';
      if (thumbWrap) thumbWrap.classList.add('is-skipp-thumb-ready');
    }

    gallery.dataset.skippMwebGalleryReady = '1';
  }

  function initPremiumMobileGallery(scope) {
    scope.querySelectorAll('.skipp-pdp-premium media-gallery').forEach(function (gallery) {
      if (gallery.dataset.skippMwebGalleryScheduled === '1') return;
      gallery.dataset.skippMwebGalleryScheduled = '1';
      requestAnimationFrame(function () {
        bootstrapPremiumMobileGallery(gallery);
      });
    });
  }

  function bindPremiumThumbCarousel(list) {
    var gallery = list.closest('media-gallery');

    list._skippCenterForMedia = function (mediaId) {
      syncPremiumThumbsForMedia(list, mediaId);
    };

    list.addEventListener(
      'click',
      function (event) {
        var btn = event.target.closest('.thumbnail');
        if (!btn) return;
        var item = btn.closest('[data-target]');
        if (!item || !item.dataset.target || !gallery) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        selectPremiumThumb(list, gallery, item.dataset.target);
      },
      true
    );
  }

  function initPremiumThumbCarousel(scope) {
    scope
      .querySelectorAll(
        '.skipp-pdp-premium .product-thumbnails--strip .skipp-pdp-thumb-strip, .skipp-pdp-premium .product-thumbnails--overlay .skipp-pdp-thumb-carousel'
      )
      .forEach(function (list) {
      if (list.dataset.skippThumbCarouselBound === '1') return;
      var items = list.querySelectorAll('.thumbnail-list__item:not([data-skipp-clone])');
      if (items.length <= 1) {
        var wrap = list.closest('.product-thumbnails--strip, .product-thumbnails--overlay');
        if (wrap) wrap.hidden = true;
        return;
      }
      list.dataset.skippThumbCarouselBound = '1';
      bindPremiumThumbCarousel(list);
    });
  }

  function init(root) {
    var scope = root && root.querySelector ? root : document;
    initAccordions(scope);
    initPdpDetailsGrid(scope);
    initDesktopGallery(scope);
    initPremiumThumbCarousel(scope);
    initMobileGalleryScroll(scope);
    initPremiumMobileGallery(scope);
    initPdpDeliveryEta(scope);
    syncStickyPurchaseBar(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target) init(e.target);
  });
})();
